import React from "react";
import { Checkbox, FormControlLabel, FormGroup, makeStyles } from "@material-ui/core";
import {  Delete } from '@material-ui/icons';
import CardNodata from './../../../../../common/cardNoData';
import { actionTypes } from './../../../../../../redux/bourse/report_trade_detail';
import { useDispatch, useSelector } from "react-redux";


let useStyles = makeStyles((theme) => ({
    root: {
        // marginTop: 50,
        width: '40%',
        boxShadow: 'rgba(0, 0, 0, 0.06) 0px 0px 20px 0px',
        borderRadius: 10,
        backgroundColor: 'rbg(255,255,255)',
        padding: '45px 30px',
        minHeight: 600,
        [theme.breakpoints.down("1100")]: {
            width: '100%',
            minHeight: 'auto',
        },

    },
    gridItem: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    cardStock: {
        margin: '5px 0px'
    },
    titleStock: {
        fontWeight: 'bold',
    },
    head: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
        [theme.breakpoints.down("500")]: {
            width: '100%',
            justifyContent: 'center',
            flexDirection: 'column'
        },
    },
    gridBtn: {
        [theme.breakpoints.down("500")]: {
            width: '100%',
            margin: "10px 0px",
        },
    },
    button: {
        backgroundColor: "#E60001",
        color: "white",
        border: 0,
        borderRadius: "8px",
        marginRight: 10,
        width: 90,
        height: 44,
        boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
        [theme.breakpoints.down("md")]: {
            width: 120,
            height: 40,
        },
        [theme.breakpoints.down("500")]: {
            width: '100%',
        },
    },
    buttonDisable: {
        backgroundColor: "gray",
        color: "white",
        border: 0,
        borderRadius: "8px",
        marginRight: 10,
        width: 90,
        height: 44,
        boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
        [theme.breakpoints.down("md")]: {
            width: 120,
            height: 40,
        },
        [theme.breakpoints.down("500")]: {
            width: '100%',
        },
    },
    gridHead: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20,
        [theme.breakpoints.down("400")]: {
            justifyContent: 'center',
            flexDirection:'column-reverse'
        },
    },
    DeleteIcons: {
        fill: 'red',
        cursor: 'pointer',
        [theme.breakpoints.down("400")]: {
        marginBottom:20
        },
    },
    titleHead: {
        fontSize: "1.125rem",
        fontWeight: 'bold',
    }
}))

export default function Index({ stock, setStock, data }) {

    let classes = useStyles();
    let dispatch = useDispatch()

    const stateReducer = useSelector(state => state?.report_trade_detail_reducer)

    const handelChange = (stockKeys, indexItem, value) => {

        setStock((prev) => ({
            ...prev,
            [stockKeys]: {
                ...prev?.[stockKeys],
                ['keys']: prev?.[stockKeys]?.['keys']
                    ?.map((item) => {
                        if (indexItem === item?.label) {
                            return { ...item, check: value }
                        }
                        return item
                    })
            }
        }))
    }

    const handelDelteStock = (key) => {

        let obj = {}
        Object.keys(stock)
            .forEach((itemKeys) => {
                if (itemKeys !== key) {
                    obj[itemKeys] = stock[itemKeys]
                }
            })
        setStock(obj)
    }

    const apiSubmit = () => {

        // if (!data?.from_date || !data?.to_date) {
        //     alert('لطفا فیلد های تاریخ رو پر نمایید ')
        //     return
        // }

        dispatch(({ type: actionTypes?.reportTradeDetailEmpty }))

        let obj = {}

        let a = Object.keys(stock)?.forEach((itemKeys) => {
            obj[itemKeys] = stock[itemKeys]?.['keys']?.filter((item) => item.check)?.map((item) => item?.id)
        })


        let payload = {
            data:
            {
                offer_symbols: {
                    ...obj
                },
                // from_trade_date:'1402/09/16',
                // to_trade_date:'1402/10/16',
                // from_trade_date: data?.from_date ? dateMiladiToShamsi(data?.from_date?.split(' ')?.[0]) : '',
                // to_trade_date: data?.to_date ?dateMiladiToShamsi(data?.to_date?.split(' ')?.[0]) : '',
            }
        };

        dispatch(({ type: actionTypes?.reportTradeDetailAsync, payload: payload }))
    }

    return (
        <div className={classes['root']}>
            <div className={classes['head']}>
                <div>
                    <h3 className={classes['titleHead']}>
                        لیست کالاهای انتخاب شده :
                    </h3>
                </div>
                <div className={classes['gridBtn']}>
                    {
                        Object?.keys(stock)?.length !== 0 && (
                            <button
                                className={stateReducer?.loading ? classes['buttonDisable'] : classes['button']}
                                onClick={() => stateReducer?.loading ? '' : apiSubmit()}
                            >
                                مقایسه
                            </button>
                        )
                    }
                </div>
            </div>
            {
                Object?.keys(stock)
                    ?.map((itemKey) => {
                        return (
                            <div className={classes['cardStock']}>
                                <hr />
                                <div className={classes['gridHead']}>
                                    <p className={classes['titleStock']}>
                                        {
                                            stock?.[itemKey]?.['data']?.['body']?.['commodity_detail']?.['persianName']
                                        }
                                        {
                                            ` (${itemKey})`
                                        }
                                    </p>
                                    <div >
                                        <Delete
                                            className={classes['DeleteIcons']}
                                            onClick={() => handelDelteStock(itemKey)}
                                        />
                                    </div>
                                </div>
                                <div className={classes['gridItem']}>
                                    {
                                        stock?.[itemKey]?.['keys']
                                            .filter((cell) =>
                                                cell?.label === 'عرضه کننده' ||
                                                cell?.label === 'حجم کالای قابل عرضه' ||
                                                cell?.label === 'قیمت پایه' ||
                                                cell?.label === 'پایین ترین قیمت' ||
                                                cell?.label === 'بالاترین قیمت'
                                            )
                                            ?.map((itemChild, ind) => {
                                                return (
                                                    <FormGroup key={ind}>
                                                        <FormControlLabel control={
                                                            <Checkbox
                                                                checked={
                                                                    itemChild?.check
                                                                }
                                                                onChange={(e) => handelChange(itemKey, itemChild?.label, e.target.checked)}
                                                            />
                                                        }
                                                            label={
                                                                itemChild?.label
                                                            } />
                                                    </FormGroup>
                                                )
                                            })
                                    }
                                </div>
                                <hr />
                            </div>
                        )
                    })
            }
            {
                Object?.keys(stock)?.length === 0 && (
                    <CardNodata
                        text={'لطفا از جدول بالا کالای را انتخاب نمایید'}
                    />
                )
            }
        </div>)
}
